import { MitekService } from '@services/mitek/mitek.service';
import { UiService } from '@services/ui/ui.service';
import { AppService } from '@services/app/app.service';
import { FileButtonComponent } from './../file-button/file-button.component';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-file-button-circle',
  templateUrl: './file-button-circle.component.html',
  styleUrls: ['./file-button-circle.component.scss']
})
export class FileButtonCircleComponent extends FileButtonComponent {
  @Input() icon: string;

  constructor(
    protected appService: AppService,
    protected uiService: UiService,
    protected mitekService: MitekService
  ) {
    super(appService, uiService, mitekService);
  }
}
